import reducer, { showSystemError, hideSystemError } from './reducers'
import SystemErrorRedux from './SystemErrorRedux'

export default SystemErrorRedux

export { reducer as SystemErrorReducer, showSystemError, hideSystemError }
